import { Component, OnInit, ViewEncapsulation } from '@angular/core';

import {
    trigger,
    state,
    style,
    animate,
    transition
} from '@angular/animations';
import { DatabaseService } from '../database.service';


declare var jQuery: any;
@Component({
    selector: 'app-about',
    templateUrl: './about.component.html',
    styleUrls: ['./about.component.scss'],
    encapsulation: ViewEncapsulation.None,
    animations: [
        trigger('fadeAndZoom', [
            state('inactive', style({
                opacity: 0,
                transform: 'scale(0.8)'
            })),
            state('active', style({
                opacity: 1,
                transform: 'scale(1)'
            })),
            transition('inactive => active', animate('100ms ease-in')),
            transition('active => inactive', animate('100ms ease-out'))
        ])
    ]
})



export class AboutComponent implements OnInit {


    constructor(
        private database: DatabaseService
    ) { }


    ngOnInit(){
        console.log("ABOUT INIT");
    }


}



// WEBPACK FOOTER //
// ./src/app/about/about.component.ts